import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Pencil, Search, Trash2, UserCheck } from 'lucide-react';
import { klarysUrl } from './klarysApi';

const fr = (d) => (d ? new Date(d).toLocaleDateString('fr-FR') : '—');

const Corriger = ({ p, i, headers, onFini }) => {
  const [q, setQ] = useState('');
  const [items, setItems] = useState(null);
  const chercher = async () => {
    try { setItems((await axios.get(klarysUrl('/membres'), { headers, params: { q } })).data.items); }
    catch (e) { toast.error(e.response?.data?.detail || 'Recherche impossible'); }
  };
  const choisir = async (m) => {
    try { await axios.patch(klarysUrl(`/payeurs/${p.id}`), { membre_id: m.id }, { headers }); toast.success('Association corrigée'); onFini(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Correction impossible'); }
  };
  return (
    <div className="mt-2 space-y-1.5 text-xs" data-testid={`klarys-payeur-corriger-panneau-${i}`}>
      <div className="flex gap-2">
        <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && q.trim().length > 1 && chercher()}
          placeholder="Nom, raison sociale, e-mail, SIRET du bon membre" className="flex-1 rounded border border-slate-300 px-2 py-1" data-testid={`klarys-payeur-recherche-${i}`} />
        <button type="button" onClick={chercher} disabled={q.trim().length < 2} className="inline-flex items-center gap-1 rounded border border-slate-300 px-2 py-1 disabled:opacity-50" data-testid={`klarys-payeur-chercher-${i}`}><Search className="h-3 w-3" /> Chercher</button>
      </div>
      {items && !items.length && <p className="text-slate-500">Aucun membre trouvé.</p>}
      {items?.map((m, j) => (
        <button key={m.id} type="button" onClick={() => choisir(m)} className="block w-full rounded border border-slate-200 bg-white px-2 py-1 text-left hover:border-[#0a3d62]" data-testid={`klarys-payeur-membre-${i}-${j}`}>
          <b>{m.raison_sociale || [m.prenom, m.nom].filter(Boolean).join(' ')}</b> <span className="text-slate-500">{m.numero_membre} · {m.email}</span>
        </button>
      ))}
    </div>
  );
};

export const KlarysPayeurs = ({ headers }) => {
  const [items, setItems] = useState(null);
  const [edit, setEdit] = useState(null);
  const charger = () => axios.get(klarysUrl('/payeurs'), { headers }).then((r) => setItems(r.data.items)).catch(() => toast.error('Liste indisponible'));
  useEffect(() => { charger(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const supprimer = async (p) => {
    try { await axios.delete(klarysUrl(`/payeurs/${p.id}`), { headers }); toast.success('Association supprimée'); charger(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Suppression impossible'); }
  };
  if (!items) return <Loader2 className="mx-auto h-5 w-5 animate-spin text-[#0a3d62]" />;
  return (
    <div className="space-y-2" data-testid="klarys-payeurs">
      <p className="text-[11px] text-slate-500">Klarys retient chaque payeur que vous attribuez à un membre. Au prochain relevé, son virement est proposé en « Sûr » sur l'impayé de ce membre — vous gardez la confirmation. Liste partagée par toute l'administration.</p>
      {!items.length ? (
        <p className="rounded-lg border border-dashed border-slate-300 p-6 text-center text-sm text-slate-500" data-testid="klarys-payeurs-vide">Aucun payeur mémorisé pour l'instant.</p>
      ) : (
        <ul className="space-y-2">
          {items.map((p, i) => (
            <li key={p.id} className="rounded-lg border border-slate-200 bg-white p-3 text-xs" data-testid={`klarys-payeur-${i}`}>
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded bg-slate-100 px-1.5 py-0.5 font-mono text-[11px] text-slate-700">{p.cle}</span>
                <span className="text-slate-400">→</span>
                <span className="inline-flex items-center gap-1 font-semibold text-slate-900"><UserCheck className="h-3.5 w-3.5 text-emerald-600" />{p.membre_nom}</span>
                <span className="ml-auto flex gap-1.5">
                  <button type="button" onClick={() => setEdit(edit === p.id ? null : p.id)} className="inline-flex items-center gap-1 rounded border border-slate-300 px-2 py-1 hover:border-[#0a3d62]" data-testid={`klarys-payeur-corriger-${i}`}><Pencil className="h-3 w-3" /> Corriger</button>
                  <button type="button" onClick={() => supprimer(p)} className="inline-flex items-center gap-1 rounded border border-rose-200 px-2 py-1 text-rose-700 hover:bg-rose-50" data-testid={`klarys-payeur-supprimer-${i}`}><Trash2 className="h-3 w-3" /> Supprimer</button>
                </span>
              </div>
              <p className="mt-1 text-slate-500">Ex. : {p.exemple || '—'} · {p.nb_utilisations} attribution(s) · dernière reconnaissance {fr(p.derniere_utilisation)} · par {p.par}</p>
              {edit === p.id && <Corriger p={p} i={i} headers={headers} onFini={() => { setEdit(null); charger(); }} />}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
